export type AdminSection = 'overview' | 'home' | 'games' | 'community' | 'teacher' | 'knowledge';

export const ADMIN_NAV_ITEMS: { id: AdminSection; label: string; icon: string }[] = [
  { id: 'overview', label: 'Tổng quan', icon: 'ri-dashboard-line' },
  { id: 'home', label: 'Trang chủ', icon: 'ri-home-4-line' },
  { id: 'games', label: 'Trò chơi', icon: 'ri-gamepad-line' },
  { id: 'community', label: 'Cộng đồng', icon: 'ri-community-line' },
  { id: 'teacher', label: 'Giáo viên (KHBD)', icon: 'ri-graduation-cap-line' },
  { id: 'knowledge', label: 'Hạt giống tri thức', icon: 'ri-seedling-line' },
];
